import moment from 'moment';

import { displayConfig } from '@config/constants';

export const ucFirst = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);

export const ucSentence = (sentence: string) =>
  sentence
    .split(' ')
    .map((word) => ucFirst(word))
    .filter(Boolean)
    .join(' ');

export const dateNow = () => moment().format(displayConfig.dateFormat);
export const dateFormat = (date) => moment(date).format(displayConfig.dateFormat);
export const timeFormat = (date) => moment(date).format(displayConfig.timeFormat);
export const dateISONextDay = (date) =>
  moment(date)
    .add(1, 'day')
    .toISOString();

export const extractGraphQlError = (err) => err.message.replace(/GraphQL error: /g, '');
